export default "__VITE_ASSET__Dtc6VD9g__"